import { FieldStub } from "./_FieldStub";
import type { FieldPrimitiveProps } from "./types";

// STUB — CHG-1167 scaffold. Real impl lands ε CHG-1164 (brand variants admin).
// Contract: specs/_product/field-primitive-registry.md §1 ('color').
// Doctrine: feedback_field_primitive_components_canonical.md.

export function ColorField(props: FieldPrimitiveProps<string>) {
  return <FieldStub {...props} fieldType="color" inputType="color" />;
}
